// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__MCYte"};